import { motion } from "framer-motion";
import { Brain } from "lucide-react";

export default function InsightCard({ idx, insight }) {
  return (
    <motion.li
      key={idx}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: idx * 0.2 }}
      className="flex items-center gap-3 bg-white/10 px-6 py-4 rounded-3xl shadow-md hover:bg-purple-700/20 hover:scale-105 transition-transform duration-300 cursor-pointer"
    >
      <Brain className="w-5 h-5 text-purple-400" />
      {insight}
    </motion.li>
  );
}
